import { MoreVert } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { GridApiPro } from '@mui/x-data-grid-pro';
import React, { useState } from 'react';
import { BasicMenuList } from 'ui-component/menus';

export type RenderActionsProps = {
    onToggleEdit: () => void;
    onDelete: () => void;
    rowId: string | number;
    apiRef?: React.MutableRefObject<GridApiPro>;
};

export const RenderActions = ({ onToggleEdit, onDelete, apiRef, rowId }: RenderActionsProps) => {
    const [menuRef, setMenuRef] = useState<null | HTMLElement>(null);
    const isEditing = apiRef ? !!apiRef.current.state.editRows[rowId] : false;

    return (
        <>
            <IconButton onClick={(e) => setMenuRef(e.currentTarget)}>
                <MoreVert />
            </IconButton>
            <BasicMenuList
                open={!!menuRef}
                anchorEl={menuRef}
                onClose={() => setMenuRef(null)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                items={[
                    { text: isEditing ? 'Close Edit' : 'Edit', onClick: onToggleEdit },
                    { text: 'Delete', onClick: onDelete }
                ]}
            />
        </>
    );
};
